// CSS BBTN BACK TO TOP
var btn = $('#buttonToTop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('active-progress');
  } else {
    btn.removeClass('active-progress');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0});
});

// JS advanced
$(document).ready(function() {
  $(".accordion").on("click", function() {
    $(this).toggleClass("active");
    $(this).next().slideToggle(200);
  });
});


